import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://prevcenso.com/backend/api',
});

// Interceptor para adicionar o token em requisições, exceto para /auth/login
api.interceptors.request.use(
  (config) => {
    if (config.url?.includes('/auth/login')) {
      return config; // Não adiciona token na requisição de login
    }
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      console.warn(`Nenhum token encontrado para a requisição: ${config.url}`);
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default api;